var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalCosts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.875 6.8H8.54167C7.07421 6.8 5.68533 6.1676 4.72354 5.1017C5.66313 4.0579 7.02808 3.4 8.54167 3.4H39.2917C41.5262 3.3898 41.5245 0.0085 39.2917 0H8.54167C3.82496 0 0 3.8063 0 8.5V25.5C0 30.1937 3.82496 34 8.54167 34H35.875C38.7057 34 41 31.7169 41 28.9V11.9C41 9.0831 38.7057 6.8 35.875 6.8ZM34.1667 22.1C31.9322 22.0898 31.9322 18.7102 34.1667 18.7C36.4012 18.7102 36.4012 22.0898 34.1667 22.1Z",
    fill: "#FF8383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCosts);
export default __webpack_public_path__ + "static/media/totalCosts.5b328238ac75724b839a778825bf8587.svg";
export { ForwardRef as ReactComponent };